import type { EsmsZaloOA } from '../../types/esms';
import InfoTooltip from '../revenue/InfoTooltip';
import EsmsErrorBox from './EsmsErrorBox';

interface Props {
  oas: EsmsZaloOA[];
  isDark: boolean;
  isLoading: boolean;
  error: string | null;
}

function renderQuota(quota: any, isDark: boolean) {
  if (quota === null || quota === undefined) {
    return <span className={`text-xs ${isDark ? 'text-slate-500' : 'text-gray-400'}`}>Không có dữ liệu quota</span>;
  }
  if (typeof quota !== 'object') {
    return <span className={`font-mono text-sm ${isDark ? 'text-slate-200' : 'text-gray-800'}`}>{String(quota)}</span>;
  }
  const entries = Object.entries(quota);
  if (entries.length === 0) {
    return <span className={`text-xs ${isDark ? 'text-slate-500' : 'text-gray-400'}`}>(rỗng)</span>;
  }
  return (
    <dl className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
      {entries.map(([k, v]) => (
        <div key={k} className="contents">
          <dt className={isDark ? 'text-slate-400' : 'text-gray-500'}>{k}</dt>
          <dd className={`font-mono text-right ${isDark ? 'text-slate-200' : 'text-gray-800'}`}>
            {typeof v === 'object' ? JSON.stringify(v) : String(v)}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default function EsmsZaloOASection({ oas, isDark, isLoading, error }: Props) {
  return (
    <div className={`backdrop-blur rounded-lg p-4 sm:p-6 ${isDark ? 'bg-white/10' : 'bg-white border border-gray-200 shadow-sm'}`}>
      <h3 className={`text-lg font-semibold mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Zalo OA
        <InfoTooltip isDark={isDark} text={'Danh sách Zalo Official Account đã đăng ký + quota còn lại.\n\nNguồn: eSMS ZNS/GetListZOA + GetZaloQuotaByOAID.'} />
      </h3>

      {isLoading ? (
        <div className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>Đang tải...</div>
      ) : error ? (
        <EsmsErrorBox error={error} isDark={isDark} compact />
      ) : oas.length === 0 ? (
        <div className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>Chưa có Zalo OA nào</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {oas.map((oa) => (
            <div key={oa.oaid} className={`rounded-lg p-3 ${isDark ? 'bg-white/5' : 'bg-gray-50 border border-gray-100'}`}>
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>{oa.name || '(no name)'}</p>
                  <p className={`text-xs font-mono ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>OAID: {oa.oaid}</p>
                </div>
              </div>
              {oa.error ? (
                <div className={`text-xs ${isDark ? 'text-rose-400' : 'text-rose-600'}`}>{oa.error}</div>
              ) : (
                renderQuota(oa.quota, isDark)
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
